// extracted by mini-css-extract-plugin
export default {"container":"PillTabs_container__ID27e"};